import { debounce } from 'lodash';
var debounceTimeout = 400;
var debounceRequest = debounce(function (inputValue, onSearchRequest, isSearchForTracks) {
  return onSearchRequest(inputValue, isSearchForTracks);
}, debounceTimeout);
export default debounceRequest;